export default __webpack_public_path__ + "static/media/Santiago-Innova-logo.17363463.png";